import React from 'react';
import IconContainer from './icon_container';

export default props => (
  <IconContainer viewBox="0 0 138 138" {...props} className="awaySignIcon">
    <g fill="none" fillRule="evenodd">
      <g>
        <circle fill="#FFF" cx="69" cy="69" r="69" />
        <g stroke="#FFF" strokeWidth="1.28" strokeLinecap="round">
          <path d="M49.91 56.91h25.454M49.91 79.818h25.454M49.91 64.545h17.193M49.91 72.182h17.193" />
        </g>
      </g>
      <g transform="translate(27 30)">
        <path
          d="M41.31 4.552L11.353 40.01M44.208 4.552L73.68 40.01"
          stroke="#979797"
          strokeWidth=".5"
          strokeLinecap="square"
        />
        <path
          d="M42.396 6.47c-1.8 0-3.26-1.45-3.26-3.236 0-1.786 1.46-3.234 3.26-3.234 1.8 0 3.26 1.448 3.26 3.234 0 1.787-1.46 3.235-3.26 3.235zm.06-1.798c.768 0 1.39-.617 1.39-1.378 0-.76-.622-1.377-1.39-1.377-.767 0-1.39.616-1.39 1.377 0 .76.623 1.378 1.39 1.378z"
          fill="#6DBD6D"
        />
        <rect fill="#009B00" y="19.646" width="86" height="49.354" rx="3.825" />
        <text fontSize="18" fontWeight="400" letterSpacing="1.414" fill="#FFF">
          <tspan x="15.953" y="49.896">
            AWAY
          </tspan>
        </text>
      </g>
    </g>
  </IconContainer>
);



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/icons/away_sign_icon.jsx